/**
 * Presentation Layer - MedicalReservationsUploadPage
 * 診療予約CSVアップロードページコンポーネント
 *
 * ページのエントリーポイント。タイトル表示とコンテナの組み込みを行う。
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';

import { MedicalReservationsUploadContainer } from './container';

/**
 * 診療予約CSVアップロードページ
 *
 * @description
 * 診療予約CSVアップロード画面のエントリーポイント。
 * LocalizationProviderでラップしてコンテナをレンダリングする。
 *
 * @returns {React.ReactElement} ページコンポーネント
 *
 * @example
 * // App.tsx でのルーティング設定
 * <Route path="/appointments/upload" element={<MedicalReservationsUploadPage />} />
 */
const MedicalReservationsUploadPage: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h4" gutterBottom>
          診療予約CSVアップロード
        </Typography>

        {/* メインコンテンツ */}
        <MedicalReservationsUploadContainer />
      </Box>
    </LocalizationProvider>
  );
};

export { MedicalReservationsUploadPage };
